import React, { FC } from 'react';
import { validators } from 'utils/formValidation';
import { faAt, faPhone } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@fattureincloud/fic-design-system';

type Props = { attivitaReferente: string; attivitaReferenteContatto?: string };
type ContactType = 'email' | 'tel';

const cleanNumber = (value: string) => value.replace('+', '').replace('-', '').replace(/\s/g, '');

export const AppplicantView: React.FC<Props> = ({ attivitaReferente, attivitaReferenteContatto }) => {
  const getContactType = (contact: string): ContactType | undefined => {
    const numberCheck = validators.isANumber(cleanNumber(contact));
    if (numberCheck === undefined) {
      return 'tel';
    }
    const emailCheck = validators.isValidEmail(contact);
    return emailCheck === undefined ? 'email' : undefined;
  };

  const type = attivitaReferenteContatto ? getContactType(attivitaReferenteContatto) : undefined;

  return attivitaReferente ? (
    <div className="w-100 mb-3">
      <p className="caption font__grey tran-uppercase">Referente</p>

      <div className="d-flex align-items-center">
        <p>{attivitaReferente}</p>
        {attivitaReferenteContatto && <p className="ml-2 font__grey">({attivitaReferenteContatto})</p>}
      </div>
      {attivitaReferenteContatto && type && <CallToAction value={attivitaReferenteContatto} type={type} />}
    </div>
  ) : null;
};

type ActionProps = { value: string; type: ContactType };
const CallToAction: FC<ActionProps> = ({ value, type }) => (
  <Button
    text="Contatta referente"
    color="yellow"
    type="secondary"
    iconLeft={{ icon: type === 'email' ? faAt : faPhone }}
    size="medium"
    onClick={() => window.open(`${type === 'tel' ? 'tel' : 'mailto'}:${value}`)}
  />
);
